export default "__VITE_ASSET__z2HNKzYg__"